import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useEntityCreate } from '../../../../features/entities/hooks';
import {
  OpenInfoForms,
  fetchOpenInfoCreate,
  IOpenInfo,
  OPEN_INFO_INITIAL_VALUES,
} from '../../../../features/open-info';
import { CabinetContainer } from '../../../../components/cabinet-container';
import { ROUTE_OPEN_INFO } from '../../../../common/constants';
import { PageTitle } from '../../../../components/page-title';

export const OpenInfoCreatePage: FC = () => {
  const { t } = useTranslation();
  const { isLoading, handleValid } = useEntityCreate<IOpenInfo>({
    entity: 'openInfo',
    thunk: fetchOpenInfoCreate,
    nextPath: ROUTE_OPEN_INFO,
  });

  return (
    <>
      <Helmet>
        <title>{t('open.info.create')}</title>
      </Helmet>
      <CabinetContainer>
        <PageTitle title={t('open.info.create.title')} mb={3} />
        <OpenInfoForms
          onValid={handleValid}
          isLoading={isLoading}
          defaultValues={OPEN_INFO_INITIAL_VALUES}
        />
      </CabinetContainer>
    </>
  );
};
